import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout';
import PageTransition from './components/PageTransition';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrdersListPage from './pages/OrdersListPage';
import DispatchedOrders from './pages/DispatchedOrders';
import ReturnedOrdersPage from './pages/ReturnedOrdersPage';
import Returns from './pages/Returns';
import Inventory from './pages/Inventory';
import StockBatches from './pages/StockBatches';
import Products from './pages/Products';
import Analytics from './pages/Analytics';
import SalesAnalytics from './pages/SalesAnalytics';
import ProfitDistribution from './pages/ProfitDistribution';
import Owners from './pages/Owners';
import OwnerDashboard from './pages/OwnerDashboard';
import Messages from './pages/Messages';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route element={<Layout />}>
          <Route
            index
            element={
              <PageTransition>
                <Dashboard />
              </PageTransition>
            }
          />
          <Route
            path="orders"
            element={
              <PageTransition>
                <Orders />
              </PageTransition>
            }
          />
          <Route path="orders/pending" element={<Navigate to="/orders" replace />} />
          <Route path="orders/completed" element={<Navigate to="/orders?tab=completed" replace />} />
          <Route
            path="orders/confirmed"
            element={
              <PageTransition>
                <OrdersListPage
                  title="Confirmed Orders"
                  subtitle="Orders confirmed and ready for dispatch"
                  statusFilter="Confirmed"
                  showAdvance
                />
              </PageTransition>
            }
          />
          <Route path="orders/processing" element={<Navigate to="/orders/confirmed" replace />} />
          <Route path="orders/packed" element={<Navigate to="/orders/confirmed" replace />} />
          <Route
            path="orders/dispatched"
            element={
              <PageTransition>
                <DispatchedOrders />
              </PageTransition>
            }
          />
          <Route
            path="orders/delivered"
            element={
              <PageTransition>
                <OrdersListPage
                  title="Delivered Orders"
                  subtitle="Successfully delivered orders"
                  statusFilter="Delivered"
                />
              </PageTransition>
            }
          />
          <Route
            path="orders/returned"
            element={
              <PageTransition>
                <ReturnedOrdersPage />
              </PageTransition>
            }
          />
          <Route
            path="orders/cancelled"
            element={
              <PageTransition>
                <OrdersListPage
                  title="Cancelled Orders"
                  subtitle="Cancelled orders"
                  statusFilter="Cancelled"
                />
              </PageTransition>
            }
          />
          <Route
            path="returns"
            element={
              <PageTransition>
                <Returns />
              </PageTransition>
            }
          />
          <Route
            path="inventory"
            element={
              <PageTransition>
                <Inventory />
              </PageTransition>
            }
          />
          <Route
            path="stock-batches"
            element={
              <PageTransition>
                <StockBatches />
              </PageTransition>
            }
          />
          <Route
            path="products"
            element={
              <PageTransition>
                <Products />
              </PageTransition>
            }
          />
          <Route
            path="analytics"
            element={
              <PageTransition>
                <Analytics />
              </PageTransition>
            }
          />
          <Route
            path="sales-analytics"
            element={
              <PageTransition>
                <SalesAnalytics />
              </PageTransition>
            }
          />
          <Route
            path="profit-distribution"
            element={
              <PageTransition>
                <ProfitDistribution />
              </PageTransition>
            }
          />
          <Route
            path="owners"
            element={
              <PageTransition>
                <Owners />
              </PageTransition>
            }
          />
          <Route
            path="messages"
            element={
              <PageTransition>
                <Messages />
              </PageTransition>
            }
          />
          <Route
            path="owners/:slug"
            element={
              <PageTransition>
                <OwnerDashboard />
              </PageTransition>
            }
          />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}
